// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19nmK","title":"Header_title__1o33h","side":"Header_side__3Lg59"};